export default {
  fields: {
    discount: {
      label: 'Descuento',
    },
    usage_threshold: {
      label: 'Importe mínimo del pedido',
    },
    max_discount: {
      label: 'Importe máximo de descuento',
    },
  },
};
